import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type InsertPaymentMethodMutationVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
  name: Types.Scalars['String']['input'];
  primary?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  type: Types.Scalars['String']['input'];
  gatewayToken: Types.Scalars['String']['input'];
  gateway: Types.Scalars['String']['input'];
  accountType?: Types.InputMaybe<Types.Scalars['String']['input']>;
  accountNumber: Types.Scalars['bigint']['input'];
  cardType?: Types.InputMaybe<Types.Scalars['String']['input']>;
  expiration?: Types.InputMaybe<Types.Scalars['smallint']['input']>;
  routingNumber?: Types.InputMaybe<Types.Scalars['bigint']['input']>;
  source?: Types.InputMaybe<Types.Scalars['String']['input']>;
  bankName?: Types.InputMaybe<Types.Scalars['String']['input']>;
  accountHolderType?: Types.InputMaybe<Types.Scalars['String']['input']>;
  pendingSetupIntentId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type InsertPaymentMethodMutation = { __typename?: 'mutation_root', insert_arpaymentmethods?: { __typename?: 'arpaymentmethods_mutation_response', returning: Array<{ __typename?: 'arpaymentmethods', id: number, customer_id: number }> } | null };


export const InsertPaymentMethodDocument = gql`
    mutation insertPaymentMethod($customerId: bigint!, $name: String!, $primary: Boolean, $type: String!, $gatewayToken: String!, $gateway: String!, $accountType: String, $accountNumber: bigint!, $cardType: String, $expiration: smallint, $routingNumber: bigint, $source: String, $bankName: String, $accountHolderType: String, $pendingSetupIntentId: String) {
  insert_arpaymentmethods(
    objects: {active: true, customer_id: $customerId, name: $name, primary: $primary, type: $type, gateway_token: $gatewayToken, gateway: $gateway, account_type: $accountType, account_number: $accountNumber, card_type: $cardType, expiration: $expiration, routing_number: $routingNumber, source: $source, bank_name: $bankName, account_holder_type: $accountHolderType, pending_setup_intent_id: $pendingSetupIntentId}
  ) {
    returning {
      id
      customer_id
    }
  }
}
    `;
export type InsertPaymentMethodMutationFn = Apollo.MutationFunction<InsertPaymentMethodMutation, InsertPaymentMethodMutationVariables>;

/**
 * __useInsertPaymentMethodMutation__
 *
 * To run a mutation, you first call `useInsertPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertPaymentMethodMutation, { data, loading, error }] = useInsertPaymentMethodMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      name: // value for 'name'
 *      primary: // value for 'primary'
 *      type: // value for 'type'
 *      gatewayToken: // value for 'gatewayToken'
 *      gateway: // value for 'gateway'
 *      accountType: // value for 'accountType'
 *      accountNumber: // value for 'accountNumber'
 *      cardType: // value for 'cardType'
 *      expiration: // value for 'expiration'
 *      routingNumber: // value for 'routingNumber'
 *      source: // value for 'source'
 *      bankName: // value for 'bankName'
 *      accountHolderType: // value for 'accountHolderType'
 *      pendingSetupIntentId: // value for 'pendingSetupIntentId'
 *   },
 * });
 */
export function useInsertPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<InsertPaymentMethodMutation, InsertPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertPaymentMethodMutation, InsertPaymentMethodMutationVariables>(InsertPaymentMethodDocument, options);
      }
export type InsertPaymentMethodMutationHookResult = ReturnType<typeof useInsertPaymentMethodMutation>;
export type InsertPaymentMethodMutationResult = Apollo.MutationResult<InsertPaymentMethodMutation>;
export type InsertPaymentMethodMutationOptions = Apollo.BaseMutationOptions<InsertPaymentMethodMutation, InsertPaymentMethodMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/billing/queries/insertPaymentMethod.mutation.gql}
 */
export async function insertPaymentMethod(
  variables: InsertPaymentMethodMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<InsertPaymentMethodMutation['insert_arpaymentmethods']>
export async function insertPaymentMethod(
  variables: InsertPaymentMethodMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<InsertPaymentMethodMutation>
export async function insertPaymentMethod(
  variables: InsertPaymentMethodMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<InsertPaymentMethodMutation['insert_arpaymentmethods'] | InsertPaymentMethodMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<InsertPaymentMethodMutation>(
    InsertPaymentMethodDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_arpaymentmethods
}